import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup
import {
  registerEmptyKit,
  setPdfData,
} from "../../../redux/slice/KitManagementSlice";
import { NavLink, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { usePic } from "../../../context/PicProvider";

// Define your validation schema
const validationSchema = Yup.object({
  quantity: Yup.number()
    .positive("Quantity must be a positive number")
    .integer("Quantity must be an integer")
    .required("Quantity is required"),
});

const CreateEmptyKit = () => {
  const initialValues = { quantity: "" };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsLoading } = usePic();
  const {
    values,
    setValues,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: () => {},
  });

  useEffect(() => {
    setValues({ ...values });
  }, []);

  const onChangeToNumber = (value) => {
    if (typeof value === "number") return value;
    const numericValue = parseFloat(value);
    return !isNaN(numericValue) && isFinite(numericValue)
      ? numericValue
      : value;
  };

  const handleBatchCreate = async (type) => {
    if (Object.keys(errors).length > 0) {
      return;
    }
    setIsLoading(true);
    const quantity = { quantity: parseInt(values.quantity, 10) };
    try {
      const res = await dispatch(registerEmptyKit(quantity));
      if (res?.payload?.status === 200) {
        dispatch(setPdfData(res?.payload?.data));
        resetForm();
        setValues({ ...initialValues });
        if (type === "excel") {
          // Generate Excel file
          const worksheetData = res.payload.data.map((item) => ({
            QR_link: item.qr_link,
            // Add other fields if needed
          }));
          const worksheet = XLSX.utils.json_to_sheet(worksheetData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Kit Data");
          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], {
            type: "application/octet-stream",
          });
          const url = window.URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.download = "kit_data.xlsx";
          link.click();
          window.URL.revokeObjectURL(url);
        } else {
          navigate("/kitpdf");
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white flex-grow-1 d-flex flex-column popup-layout">
      <div
        className="position-sticky bg-white header-section"
        style={{ zIndex: 1 }}
      >
        <h4 className="text-center m-0 fw-bold">Create Empty Kits</h4>
        <hr className="my-3 my-md-4" />
      </div>
      <Form
        onSubmit={handleSubmit}
        className="d-flex flex-column flex-grow-1 justify-content-between"
      >
        <div className="row">
          <div className="col-12 col-sm-6 col-md-3">
            <Form.Group controlId="formBasicQuantity">
              <Form.Control
                type="text"
                name="quantity"
                onChange={handleChange}
                value={onChangeToNumber(values.quantity)}
                onBlur={handleBlur}
                placeholder="Batch Quantity"
              />
              {errors.quantity && touched.quantity && (
                <p className="text-danger">{errors.quantity}</p>
              )}
            </Form.Group>
          </div>
        </div>
        <div className="position-sticky bg-white footer-section">
          <hr />
          <div className="d-flex justify-content-end gap-3 flex-wrap">
            <NavLink to="/kit" className="btn btn-dark" type="button">
              Cancel
            </NavLink>
            <button
              className="btn btn-primary"
              type="submit"
              onClick={() => handleBatchCreate("pdf")} // Pass "pdf" type
            >
              Export as PDF
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              onClick={() => handleBatchCreate("excel")} // Pass "excel" type
            >
              Export as Excel
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CreateEmptyKit;
